module.exports = __webpack_public_path__ + "static/media/Bluelab PeriPod L3.3fda8591.webp";